import { createSlice, Dispatch, PayloadAction } from "@reduxjs/toolkit";
import { GetStateFn } from "../../utils/dispatchUtils";
import { parseWithExpectedVersion } from "../../utils/stateUtils";

export const configurationManagerTabViewOptionsSliceName = "configurationManagerTabView";

// the version of the state structure: used to detect an incompatible state in localStorage => if found: drop incompatible state and use fallback
const stateVersion = 0;

export enum ConfigurationManagerTabKey {
  MBV = "mbv",
  PACKAGES = "packages",
  PRESETS = "presets",
  TRIGGER = "trigger",
  ID_COLOR_MATRIX = "idColorMatrix",
}

export type ConfigurationManagerTabViewOptionsState = {
  version?: number;
  selectedTab: ConfigurationManagerTabKey;
};

const fallback: ConfigurationManagerTabViewOptionsState = {
  version: stateVersion,
  selectedTab: ConfigurationManagerTabKey.MBV,
};

const initialState: ConfigurationManagerTabViewOptionsState = parseWithExpectedVersion(
  localStorage.getItem(configurationManagerTabViewOptionsSliceName),
  stateVersion,
) ?? fallback;

// if selectedTab does not exist, set default fallback value
if (initialState.selectedTab === undefined) initialState.selectedTab = fallback.selectedTab;

const configurationManagerTabViewOptionsSlice = createSlice({
  name: configurationManagerTabViewOptionsSliceName,
  initialState,
  reducers: {
    setLayoutProfileString(_, action: PayloadAction<string>) {
      return JSON.parse(action.payload);
    },
    setConfigurationManagerTabViewSelectedTab(state: ConfigurationManagerTabViewOptionsState, action: PayloadAction<ConfigurationManagerTabKey>) {
      state.selectedTab = action.payload;
    },
  },
});

export type ConfigurationManagerTabViewOptionsRootState = { [configurationManagerTabViewOptionsSliceName]: ConfigurationManagerTabViewOptionsState };
export const selectConfigurationManagerTabViewOptions = (state: ConfigurationManagerTabViewOptionsRootState) => {
  return state[configurationManagerTabViewOptionsSliceName];
};

export const setConfigurationManagerTabViewSelectedTab = (tabKey: ConfigurationManagerTabKey) => (dispatch: Dispatch, getState: GetStateFn) => {
  dispatch(configurationManagerTabViewOptionsSlice.actions.setConfigurationManagerTabViewSelectedTab(tabKey));
  persistState(getState);
};

function persistState(getState: GetStateFn) {
  localStorage.setItem(configurationManagerTabViewOptionsSliceName, JSON.stringify(selectConfigurationManagerTabViewOptions(getState())));
}

export const configurationManagerTabViewOptionsReducer = configurationManagerTabViewOptionsSlice.reducer;
